import { defineComponent as _defineComponent } from 'vue'

import { NewAudioFragmentV1 } from '@ilteducation/content-registry-types';

type Props = {
  title: string;
  item?: NewAudioFragmentV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Create',
  props: {
    title: null,
    item: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  item?: NewAudioFragmentV1;
}



return { __sfc: true,props }
}

})